<div class="item" [class.item_clickable]="clickable" (click)="selectItem()">
  <div class="item__title">
    {{ itemTitle }}
  </div>

  <div class="item__buttons">
    <button
      tuiIconButton
      [iconStart]="'@tui.trash-2'"
      appearance="icon"
      size="s"
      class="item__buttons_delete"
      (click)="onClickDeleteButton($event)"
    ></button>
  </div>
</div>
